import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions as rootActions } from "../actions";
import { NAME as ROOT_NAME } from "../../Root/reducer"
import { isSaving } from "../../Root/saving"
import { NON_NEGATIVE, nonNegativeChange } from "../../Root/nonNegative"
import { NAME as MONITOR_NAME } from "../reducer";
import { actions as productTypeActions } from "../../ProductType/actions";
import { NAME as PRODUCT_TYPE } from "../../ProductType/reducer";
import {Button, Input, InputLabel, Select, TextField,} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";

import ResponsiveDrawer from "../../../components/ResponsiveDrawer";
import ConfirmDeleteButton from "../../../components/ConfirmDeleteButton";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from '@mui/material/InputAdornment';

import { withStyles } from "@material-ui/core/styles";


function mapStateToProps(state) {
  return {
    ...state[MONITOR_NAME],
    productTypeList: state[PRODUCT_TYPE].productTypeList,
    saving: isSaving(state[ROOT_NAME], "MONITOR_EDIT"),
  };
}

const styles = (theme) => ({
  autocomplete: {
    height: "100%",
    "& .MuiAutocomplete-root": {
      height: "100%",
    },
    "& .MuiTextField-root": {
      height: "100%",
    },
    "& .MuiAutocomplete-inputRoot": {
      height: "100%",
    },
    "& .MuiFormControl-root": {
      height: "100%",
    }
  },
  button: {
    height: "100%",
    "& .MuiFormControl-root": {
      height: "100%"
    },
    "& .MuiButtonBase-root": {
      height: "100%"
    }
  }
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...rootActions,
      getProductTypeList: productTypeActions.getProductTypeList,
    },
    dispatch
  );

class CreateMonitor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: this.props.selected.price,
      description: this.props.selected.description,
      rows: null,
      showFields: false,
    };
  }

  componentDidMount() {
    if (this.props.selected && this.props.selected.id) {
      this.props.getWarehouseProducts(this.props.selected.id);
      this.props.getProductTypeList();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected.products !== this.props.selected.products && this.state.rows === null) {
      this.setState({
        rows: this.props.selected.products.map((product) => ({
          id: product.id || `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
          product_id: product.product_id,
          price: product.product_price !== undefined && product.product_price !== null ? product.product_price : "",
          error: false,
        })),
      });
    }
  }

  toggleFields = () => {
    this.setState((prevState) => ({ showFields: !prevState.showFields }));
  };

  addRow = () => {
    this.setState((prevState) => ({
      rows: [...prevState.rows, { id: Date.now(), value: "" }],
    }));
  };

  removeRow = (id) => {
    this.setState((prevState) => ({
      rows: prevState.rows.filter((row) => row.id !== id),
    }));
  };

  handleValueChange = (id, field, value) => {
    this.setState((prevState) => {
      const updatedRows = prevState.rows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      );
  
      return { rows: updatedRows };
    });
  };

  // handleSave = () => {
  //   let hasError = false;
  //   const updatedRows = this.state.rows.map((row) => {
  //     if (!row.product || !row.description) {
  //       hasError = true;
  //       return { ...row, error: true };
  //     }
  //     return row;
  //   });

  //   if (hasError) {
  //     this.setState({ rows: updatedRows });
  //   } else {
  //     console.log("Saved!");
  //     this.toggleFields();
  //   }
  // };

  handleCancel = () => {
    this.setState({
      rows: this.props.selected.products.map((product) => ({
        id: product.id || `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
        product_id: product.product_id,
        price: product.product_price !== undefined && product.product_price !== null ? product.product_price : "",
        error: false,
      })),
      showFields: false,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid component={Paper} container spacing={3}>
        <Grid item xs={5}>
          <h3>Условия доставки: {this.props.selected.shippingConditions}</h3>
        </Grid>
        <Grid item xs={5}>
          <h3>Название: {this.props.selected.name}</h3>
        </Grid>
        <Grid item xs={2}>
          <ConfirmDeleteButton
            label="Удалить монитор"
            title="Удалить склад?"
            text={`Склад «${this.props.selected.name}» будет удалён безвозвратно вместе со своими ценами и списком культур.`}
            confirmLabel="Удалить склад"
            onConfirm={() => {
              this.props.deleteMonitor({
                id: this.props.selected.id,
              });
              this.props.editMonitorAction({
                selected: null,
                showEdit: false,
              });
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              type="number"
              label="Цена"
              inputProps={NON_NEGATIVE}
              variant="outlined"
              defaultValue={this.props.selected.price}
              onChange={nonNegativeChange((e) => this.setState({ price: e.target.value }))}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-basic"
              multiline
              label="Заметки"
              variant="outlined"
              defaultValue={this.props.selected.description}
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </FormControl>
        </Grid>

        {this.state.rows ? (this.state.rows.map((row) => (
          <Grid item xs={12} key={row.id}>
            <Grid container spacing={3}>
              <Grid item sm={7}>
                <FormControl fullWidth className={classes.autocomplete}>
                  <Autocomplete
                    openText="Открыть список"
                    closeText="Закрыть список"
                    clearText="Очистить"
                    options={this.props.productTypeList.filter(
                      (option) => !this.state.rows.some(row => row.product_id === option.id) || row.product_id === option.id
                    )} // A filter to exclude previously selected options
                    getOptionLabel={(option) => option.name}
                    value={
                      this.props.productTypeList.find(
                        p => p.id === row.product_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                    console.log("before: ", this.state.rows)
                      this.handleValueChange(
                        row.id,
                        "product_id",
                        newValue ? newValue.id : ""
                      )      
                    }
                  }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Культура"
                        variant="outlined"
                        error={row.error && !row.product_id}
                        helperText={
                          row.error && !row.product_id ? "Поле обязательно" : ""
                        }
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item sm={3}>
                <TextField
                  fullWidth
                  label="Цена"
                  inputProps={NON_NEGATIVE}
                  type='number'
                  variant="outlined"
                  value={row.price}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Грн.</InputAdornment>
                  }}
                  onChange={nonNegativeChange((e) =>
                    this.handleValueChange(row.id, "price", e.target.value)
                  )}
                  error={row.error && !row.price}
                  helperText={row.error && !row.price ? "Поле обязательно" : ""}
                />
              </Grid>
              <Grid item sm={2}>
                <FormControl fullWidth className={classes.button}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => this.removeRow(row.id)}
                  >
                    Удалить
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        ))
      ):(<p>Загрузка...</p>)}

          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={6}>
                <Button size='large' variant="contained" fullWidth onClick={this.addRow}>
                  + Добавить ещё культуру
                </Button>
              </Grid>
              {/* <Grid item xs={2}>
                <Button size='large' variant="contained" fullWidth onClick={this.handleSave}>
                  Сохранить
                </Button>
              </Grid> */}
              <Grid item xs={4}>
                <Button size='large' variant="contained" fullWidth onClick={this.handleCancel}>
                  Вернуть культуры как были
                </Button>
              </Grid>
            </Grid>
          </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item sm={6}>
              <FormControl fullWidth>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.props.saving}
                  onClick={() => {
                    this.props.editMonitor({
                      name: this.props.selected.name,
                      shippingConditions:
                        this.props.selected.shippingConditions,
                      price: this.state.price,
                      description: this.state.description,
                      id: this.props.selected.id,
                      products: this.state.rows.map(row => ({
                        product: row.product_id,
                        price: row.price,
                      }))
                    });
                  }}
                >
                  Сохранить монитор
                </Button>
              </FormControl>
            </Grid>
            <Grid item sm={6}>
              <FormControl fullWidth>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.props.editMonitorAction({
                      selected: null,
                      showEdit: false,
                    });
                  }}
                >
                  Закрыть без сохранения
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateMonitor));
